import Axios, { AxiosError, type AxiosRequestConfig, isAxiosError } from 'axios'
import { type AuthConfig, setupAuthInterceptors } from './auth'

export interface ClientConfig {
	baseUrl: string
	auth?: AuthConfig
	withCredentials?: boolean
	headers?: Record<string, string>
}

let clientConfig: ClientConfig = {
	baseUrl: '/api/v1',
}

let interceptorIds: { requestId: number; responseId: number } | null = null

export function initializeClient(config: ClientConfig): void {
	clientConfig = config
	AXIOS_INSTANCE.defaults.baseURL = config.baseUrl
	AXIOS_INSTANCE.defaults.withCredentials = config.withCredentials ?? false

	if (config.headers) {
		for (const [key, value] of Object.entries(config.headers)) {
			AXIOS_INSTANCE.defaults.headers.common[key] = value
		}
	}

	if (interceptorIds) {
		AXIOS_INSTANCE.interceptors.request.eject(interceptorIds.requestId)
		AXIOS_INSTANCE.interceptors.response.eject(interceptorIds.responseId)
		interceptorIds = null
	}

	if (config.auth) {
		interceptorIds = setupAuthInterceptors(AXIOS_INSTANCE, config.auth)
	}
}

export function getClientConfig(): ClientConfig {
	return clientConfig
}

export const AXIOS_INSTANCE = Axios.create({
	baseURL: clientConfig.baseUrl,
})

export const customFetch = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
	const promise = AXIOS_INSTANCE({
		...config,
		...options,
	}).then(({ data }) => data)

	return promise
}

export const isApiError = isAxiosError

export function createApiError(status: number, statusText: string, data?: unknown): AxiosError {
	return new AxiosError(statusText, String(status), undefined, undefined, {
		status,
		statusText,
		data,
		headers: {},
		config: { headers: {} },
	} as import('axios').AxiosResponse)
}

export type ErrorType<Error> = AxiosError<Error>
export type BodyType<BodyData> = BodyData
